import api from '../../../../../configurations/service';
import * as types from './mutation-types';

export const setUnitOfMeasureCollection = async (context, params) => {
  const body = {
    search: params?.search ?? '',
    active: true,
  };
  const { data } = await api().post('inventory.get-unit_of_measure', body);

  context.commit(types.SET_UNIT_OF_MEASURE_COLLECTION, data);
};

export const getUnitOfMeasureById = async (context, params) => {
  const { data } = await api().post('inventory.get-unit_of_measure', params);

  return data;
};
